import React from "react";
// import Header from "./home/HeaderSection";
import Footer from "./home/FooterSection";
import { Outlet } from "react-router-dom";
import "../assets/scss/App.scss";
import { SiteHeader } from "./dashboard/site-header";

const MainLayout = () => {
	return (
		<div>
			<SiteHeader />
			<Outlet />
			<Footer />
		</div>
	);
};

export default MainLayout;
